import { render, staticRenderFns } from "./ViewPromotion.vue?vue&type=template&id=1f64079f&scoped=true"
import script from "./ViewPromotion.vue?vue&type=script&lang=ts"
export * from "./ViewPromotion.vue?vue&type=script&lang=ts"
import style0 from "./ViewPromotion.vue?vue&type=style&index=0&id=1f64079f&prod&lang=scss&scoped=true"
import style1 from "./ViewPromotion.vue?vue&type=style&index=1&id=1f64079f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f64079f",
  null
  
)

export default component.exports